export default Object.freeze([
    { name: 'Level 1', value: 'Vet Staff' },
    { name: 'Level 3', value: 'Vet Owner' }
]);
